<template>
  <div class="online-progress">
    <div class="card">
      <div class="card-header">
        <span class="card-title">网络学习进度</span>
      </div>
      <div class="flex menu-bar">
        <div class="flex gap12">
          <div style="flex-shrink: 0">课程名称</div>
          <el-input
            v-model="trainingName"
            clearable
            placeholder="请输入课程名称"
          ></el-input>
        </div>
        <div class="flex">
          <el-button
            size="mini"
            icon="el-icon-search"
            type="warning"
            @click="search"
            >搜索</el-button
          >
          <el-button size="mini" icon="el-icon-search" @click="reset"
            >重置</el-button
          >
        </div>
      </div>
      <div class="card-body">
        <el-table
          :data="progressList"
          border
          :header-cell-style="{ background: '#fff6e8', color: '#515a6e' }"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="trainingTitle"
            label="培训标题"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="trainingName"
            label="课程名称"
            align="center"
          ></el-table-column>
          <el-table-column label="学习进度" align="center">
            <template slot-scope="scope">
              <el-progress
                :percentage="getProgressPercentage(scope.row)"
                :color="'#ff6b00'"
              ></el-progress>
            </template>
          </el-table-column>
          <el-table-column
            prop="classHours"
            label="课程学时"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="acquiredClassHours"
            label="获得学时"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.acquiredClassHours || 0 }}
            </template>
          </el-table-column>
          <el-table-column label="查看" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="!scope.row.isExpire && !scope.row.trainingStudyProgress"
                class="action-button"
                type="warning"
                size="mini"
                @click="onlineStudy(scope.row)"
                >在线学习</el-button
              >
              <el-button
                v-if="scope.row.isExpire"
                class="disabled-button"
                type="info"
                size="mini"
                disabled
                >课程学习时间已到期</el-button
              >
              <el-button
                v-if="scope.row.trainingStudyProgress && !scope.row.isExpire"
                class="disabled-button"
                type="info"
                size="mini"
                disabled
                >已完成学习</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pages">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="10"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { studyProgressList } from "@/api/course.js";
import { findRoute } from "@/utils/routerHelper.js";
export default {
  data() {
    return {
      trainingName: "",
      progressList: [],
      currentPage: 1,
      total: 0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      studyProgressList({
        current: this.currentPage,
        size: 10,
        trainingType: "网络",
        trainingName: this.trainingName,
      }).then((res) => {
        this.total = res.data.data.total;
        if (res.data.code == 200) {
          this.progressList = res.data.data.records.map((v) => {
            return {
              ...v,
              ...v.trainingListEntity,
            };
          });
        }
        // console.log(res)
      });
    },
    onlineStudy(course) {
      if (course.beginTime) {
        const beginTime = new Date(course.beginTime).getTime();
        const now = Date.now();
        if (now < beginTime) {
          this.$message.warning("学习未开始");
          return;
        }
      }
      if (course.endTime) {
        const endTime = new Date(course.endTime).getTime();
        const now = Date.now();
        if (now > endTime) {
          this.$message.warning("课程已结束");
          return;
        }
      }
      this.$router.push({
        path: "/personalCenter/trainingSystem/onlineStudyDetails",
        query: {
          trainingId: course.id,
        },
      });
      let routerList = [];
      let routers = [
        "/personalCenter",
        "trainingSystemProgressOnline",
        "/personalCenter/trainingSystem/onlineStudyDetails",
      ];
      for (let i = 0; i < routers.length; i++) {
        let routerData = findRoute(this.$router.options.routes, routers[i]);
        routerList.push(routerData);
      }
      this.$store.commit("routerData/changeRouterList", routerList);
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    reset() {
      this.trainingName = "";
    },
    viewDetail(item) {
      this.$message.info(`开始在线学习《${item.courseName}》`);
    },
    handleSizeChange(index) {},
    handleCurrentChange(index) {
      if (this.currentPage != index) {
        this.currentPage = index;
        this.getList();
      }
    },
    getProgressPercentage(row) {
      // 确保 duration 存在且大于 0
      if (row.duration && row.duration !== 0) {
        const percent = (row.progress / row.duration) * 100;
        // 保留两位小数，并限制在 0-100 之间
        return Math.min(100, Math.max(0, Math.round(percent * 100) / 100));
      }
      return 0; // 无效数据时显示 0%
    },
  },
};
</script>

<style lang="less" scoped>
.menu-bar {
  font-size: 14px;
  color: #606266;
  gap: 21px;
}
.gap12 {
  gap: 12px;
}
.online-progress {
  height: 100%;
  .card {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    height: 100%;

    .card-header {
      margin-bottom: 20px;

      .card-title {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }
    }

    .card-body {
      margin-top: 16px;
      .action-button {
        background: #ed9d26;
        border-radius: 4px;
        font-size: 12px;
        color: #ffffff;
        border: none;
        padding: 0 8px;
        line-height: 21px;
      }
      .disabled-button {
        background: #c0c4cc;
        border-radius: 4px;
        font-size: 12px;
        color: #ffffff;
        border: none;
        padding: 0 6px;
        line-height: 21px;
      }
    }
  }
}
.pages {
  margin-top: 34px;
  display: flex;
  justify-content: flex-end;
}

::v-deep .el-pager li.active {
  color: #ed9d26;
}
</style>
